module.exports = __webpack_public_path__ + "img/climb-up.9613d12d.svg";